export const queryJobsByCompanyIdStatusIndex = `query QueryJobsByCompanyIdStatusIndex(
    $companyId: ID!
    $first: Int
    $after: String
    $status: String
  ) {
    queryJobsByCompanyIdStatusIndex(
      companyId: $companyId
      first: $first
      after: $after
      status: $status
    ) {
        items {
            id
            companyId
            company {
              id
              name
            }
            departmentId
            department {
              id
              name
            }
            title
            referralBonus
            description
            publicLink
            location
            jobAdditionalInfo
            hiringManagerId
            hiringManager {
              id
              firstName
              lastName
            }
            shares
            views
            status
            dateCreated
            lat
            lng
            externalJobId
            subCompanyId
            subCompany {
              id
              name
            }
          }
          nextToken
    }
  }
  `;
